import { apiBaseUrl } from "./config"
import { PPIS } from "./constant/url-segment"
import { getBaseHeader } from "./utils"
import { genericFetch } from "./common-service"
import * as Model from "../../model"

function getPpiBaseUrl(): string {
	return `${apiBaseUrl}/${PPIS}`
}

export function findPpi(
	localAuthority: Model.LocalAuthority,
	signal?: AbortSignal
): Promise<Model.Ppi> {
	const url = `${getPpiBaseUrl()}/${localAuthority.id}`
	const init: RequestInit = { headers: getBaseHeader(), signal }
	return genericFetch<Model.Ppi>(url, init)
}



// WEBPACK FOOTER //
// ./src/service/sfp/ppis-service-2.ts